import { FC } from 'react';

import { DATA_SOURCE } from 'utils/types';

import BaseCustomFieldsForm from './BaseCustomFieldsForm';

const LeadCustomFields: FC = () => (
  <BaseCustomFieldsForm source={DATA_SOURCE.LEAD} />
);
export default LeadCustomFields;
